import React from 'react';
import { UploadFile } from 'antd/lib/upload/interface';
import Typography from 'antd/lib/typography';
import { FileDeleteDialog } from '@/components/appSettings/FileUpload/FileDeleteDialog';
import { FileUploadDialog } from '@/components/appSettings/FileUpload/FileUploadDialog';
import { UploadFooterText } from '@/components/appSettings/FileUpload/UploadFooterText';
import { FileStats } from '@/types';

const EMPTY_FILE_LIST: UploadFile[] = [];

const reviewAttachmentAcceptedFileTypes = [
    '.pdf',
    '.doc',
    '.docx',
    '.rtf',
    '.pages',
    '.xls',
    '.xlsx',
    '.numbers',
    '.zip',
    '.rar',
    '.plist',
    '.crash',
    '.jpg',
    '.png',
    '.mp4',
    '.avi',
];

interface ReviewAttachmentUploadViewProps {
    description: string;
    attachment?: FileStats;
    isUploading: boolean;
    isDeleting: boolean;
    handleUpload: (file: File) => void;
    handleDelete: (fileName: string) => void;
}

// Presentational upload/delete UI shared by the app-default (DefaultReviewAttachmentUpload) and
// per-release (ReleaseReviewAttachmentUpload) review attachment components.
export function ReviewAttachmentUploadView({
    description,
    attachment,
    isUploading,
    isDeleting,
    handleUpload,
    handleDelete,
}: ReviewAttachmentUploadViewProps) {
    const showDelete = !!attachment;

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography.Text>{description}</Typography.Text>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    paddingTop: showDelete ? '12px' : '24px',
                    paddingBottom: showDelete ? '12px' : '24px',
                }}
            >
                {showDelete ?
                    <FileDeleteDialog
                        fileStats={attachment}
                        handleDelete={handleDelete}
                        isLoading={isDeleting}
                        removeButtonText={'Remove File'}
                        confirmationMessage={'Are you sure you want to delete this attachment?'}
                        confirmationAcceptText={'Yes, remove'}
                        confirmationCancelText={'No'}
                    />
                :   <FileUploadDialog
                        file={EMPTY_FILE_LIST}
                        acceptedFileTypes={reviewAttachmentAcceptedFileTypes}
                        handleUpload={handleUpload}
                        isLoading={isUploading}
                    />
                }
            </div>
            <div style={{ marginBottom: '-24px' }}>
                <UploadFooterText acceptedFileTypes={reviewAttachmentAcceptedFileTypes} showFileTypes={!showDelete} />
            </div>
        </div>
    );
}
